import { Registry } from './../registry/registry';
import { ActivatedRoute, NavigationEnd } from '@angular/router';
import { AuthService, User } from '../user/auth.service';
import { FormControl } from '@angular/forms';
import { UnsplashImageService } from '../unsplash/unsplash.service';
import { RegistryFirebaseService } from '../registry/registry-firebase.service';
import { Component, OnInit, Input, ViewEncapsulation, Output, EventEmitter, OnDestroy, ElementRef, ViewChild } from '@angular/core';
import { RegistryService } from '../registry/registry.service';

import { Router } from '@angular/router';

import { FormGroup, FormArray, FormBuilder, Validators } from '@angular/forms';
import { RegistryStateStore } from '../registry/registry.state.store';
import { WebsiteStateStore } from '../website-builder/website.state.store';
import { Website } from '../website-builder/wedding';


@Component({
  selector: 'app-stripe-success-popup',
  templateUrl: './stripe-success-popup.component.html',
  styleUrls: ['./stripe-success-popup.component.scss'],
  encapsulation: ViewEncapsulation.Emulated,
  host: {
    '(document:keydown)': 'handleKeyboardEvents($event)'
  }
})


export class StripeSuccessPopupComponent implements OnInit {
  @ViewChild('serachQuery') firstNameElement: ElementRef;

  copied = false

  @Output() headerPopupEvent: EventEmitter<any>;

  @Input() showPopup: boolean = false;
  isWebsite  = false;
  registry: Registry;
  website: Website;
  constructor(private _unsplashImageService: UnsplashImageService,
    private _registryService: RegistryService,
    private _authService: AuthService,
    private router: Router,
    private _registryState: RegistryStateStore,
    private route: ActivatedRoute,
    private _registryFirebaseService: RegistryFirebaseService,
    private _websiteStateService: WebsiteStateStore,
    private _fb: FormBuilder,
  ) {
    this._authService.user.subscribe(user => {
      if (user){
      this._registryFirebaseService.initGiftsForUser(user);
      }
    });


    this.router.events.subscribe((event) => {
      if (
        (this.router.url.indexOf('/registry/stripe-connected') > -1)
        || (this.router.url.indexOf('/website/builder/launched') > -1)
        || (this.router.url.indexOf('/overview/launched') > -1)
        || (this.router.url.indexOf('/registry/launched') > -1)
        ) {
        this.showPopup = true;
        this.isWebsite = false;
        if (this.router.url.indexOf('/website/builder/launched') > -1){
          this.isWebsite = true;
        }
        let body = document.getElementsByTagName('body')[0];
        body.style.overflow = 'hidden';
      } else {
        this.showPopup = false;
      }

    });

  }


  load() {



  }
  handleKeyboardEvents(event: any) {
    if (this.showPopup && event.keyCode == 27) {

      this.close();
    }

  }

  ngOnInit() {

    this.registry = this.route.snapshot.data.registry;
    this.website = this.route.snapshot.data.website;
    if(!this.registry){
      this._registryState.getState().subscribe(state => {
        
        if(state && state.registry){
          this.registry = state.registry
        }
       
      });
    }

    if(!this.website){
      this._websiteStateService.getState().subscribe(state => {
        
        if(state && state.website){
          this.website = state.website
        }
       
      });
    }
  }


  close() {


      let body = document.getElementsByTagName('body')[0];
      body.style.overflow = "auto";
      this._registryService.emitHeaderPopupClosed();
      this.router.navigate(['/overview']);



  }

  redirectToSettings(){
    
    let body = document.getElementsByTagName('body')[0];
    body.style.overflow = "auto";
    this._registryService.emitHeaderPopupClosed();
    this.router.navigateByUrl('/registry/settings')
    //this.router.navigate(['/registry']);

  }

  copy() {
    window.navigator['clipboard'].writeText("www.hitchd.com/" + this.registry.registryName);
  }




}



// WEBPACK FOOTER //
// ./src/app/stripe-success-popup/stripe-success-popup.component.ts